<template>
  <div>
    <table-component
      ref="table"
      :tableDivId ="tableDivId"
      :show-filter="false"
      :data="fetchData"
      table-class="table"
    >
      <table-column
        :label="$t('actions.name')"
        show="name"
      />
      <table-column
        :label="$t('actions.updated_at')"
        show="updated_at"
      />
    </table-component>
  </div>
</template>
<script>
export default {
  props: {
    fetchData: { default: () => [], type: [Array, Function, Object] },
    tableDivId: { default: '', type: String }
  },
  methods: {
  }
}
</script>
<style scoped>
.table-component{
  min-height: 0px !important;
}
</style>
